var _defs, _ellipse, _path, _path2, _path3, _path4, _g, _g2, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line, _line2, _line3, _line4, _path13, _path14, _line5, _line6, _line7, _line8, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _circle, _circle2, _circle3, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _g3, _path64, _path65, _path66, _path67, _polygon, _path68, _path69, _path70, _path71, _path72, _path73, _polygon2, _path74, _path75, _path76, _path77, _path78, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _polygon3, _path79, _polygon4, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g4, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _g5, _path122, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawChildren4Rtb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "9a7f0d87-1824-4b3e-ab06-04e58600b515",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1110.65,
    height: 810.94,
    viewBox: "0 0 1110.65 810.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "96fd64a0-6351-4330-b812-2613840b356c",
    x1: 625.32,
    y1: 588.18,
    x2: 625.32,
    y2: 218.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "65aaeda9-82be-4b39-9919-e403ba36e3f2",
    x1: 933.17,
    y1: 777.5,
    x2: 933.17,
    y2: 311.68,
    xlinkHref: "#96fd64a0-6351-4330-b812-2613840b356c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "05d1d1fb-9375-46f7-a562-a16a81ed75db",
    x1: 187.32,
    y1: 814.44,
    x2: 187.32,
    y2: 271.29,
    xlinkHref: "#96fd64a0-6351-4330-b812-2613840b356c"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "children") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 562.02,
    cy: 790.32,
    rx: 478.2,
    ry: 29.18,
    transform: "translate(-98.15 13.54) rotate(-3.17)",
    fill: "#f6841f",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.34,437.14C84.92,509.35,122.12,571.76,180.92,602c122.19,62.88,397.76,30.45,603.43-6.78C890.71,576,984.23,522.88,1052.16,448.07Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.86,97.26H1033a9.38,9.38,0,1,1,0-18.75h19.5a9.38,9.38,0,1,1,0-18.75h-13.93a9.38,9.38,0,1,1,0-18.75h58.9c-13.08-5.84-28.31-10-46-12.17C890.94,9,833.6,22.12,813.37,35.62c-25,16.64-52.8,28.88-82.54,34.78-99.1,19.65-284.41,43.29-452.36-7.57C195,37.55,132.94,80.27,95.75,151.66H1165.46c-1.4-20.75-5.58-39.92-13.26-56.68A10,10,0,0,1,1145.86,97.26Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M743.63,325l-1.47-.09-15.36-.87-147.16-8.27-15.9-.9L329.4,301.71,263.72,298l-10.39-.58-9.23-.52L57.77,286.43a458.86,458.86,0,0,0,4.38,126l156.79,5.51,12.43.45,2.2.07L308,421.05l4,.13,8.58.3,75,2.64,10.28.37,35.82,1.26h.68l5.27.19,17.95.63h0l15.75.55,30,1.05.63,0,2.67.1,2.84.1h.62l47.82,1.68,13.4.48.56,0,6.45.22h0l1.2.05H588l5.67.2,17.31.61h0l6.5.23,8.35.29h.31l11.46.41,33.14,1.17,9.12.31,1,0,44.18,1.55,25.66.9,31.93,1.13,5.12.18,8.27.29,30.06,1.05,226.75,8a446.55,446.55,0,0,0,68.83-100.92ZM317.29,395a9.94,9.94,0,0,1-6.5-2.4h0a9.48,9.48,0,0,1-2.06-2.49,9.11,9.11,0,0,1-1.19-4.48,8.94,8.94,0,0,1,1.61-5.12s0,0,0,0a10.39,10.39,0,0,1,1.08-1.29,9.89,9.89,0,0,1,7.06-2.92h19.5a9.39,9.39,0,1,1,0-18.76H322.86a9.1,9.1,0,0,1-.91,0,9.36,9.36,0,0,1,.91-18.7H435.7a9.38,9.38,0,1,1,0,18.74h13.93a9.39,9.39,0,1,1,0,18.76h-19.5a9.38,9.38,0,1,1,0,18.74Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.5,152.32,387.14,170.51l-85.55,2L83.82,177.6C70.65,210.12,61.93,246.88,57.92,285H1146.55a430.44,430.44,0,0,0,15.71-68.45C1165.5,194.14,1166.81,172.49,1165.5,152.32Zm-888,82.87H258a9.59,9.59,0,0,1,9.75,9.37c0,.19,0,.38,0,.57a9.32,9.32,0,0,1-4.33,7.23,10,10,0,0,1-5.4,1.58H145.18a9.38,9.38,0,1,1,0-18.75h19.51a9.38,9.38,0,1,1,0-18.75H150.76a9.38,9.38,0,1,1,0-18.75H263.6a9.38,9.38,0,1,1,0,18.75h13.93a9.88,9.88,0,0,1,4.63,1.14,9.33,9.33,0,0,1,5.12,8.23A9.6,9.6,0,0,1,277.53,235.19Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.86,596.39s28.55-67.63,81.86-92.72c22.38-10.53,40.88-27.41,52.22-48.73A182.39,182.39,0,0,0,793,423.33",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.52,407.33c-5.55,6.72-34.32,16.52-34.32,16.52s3.47-29.15,9-35.86a16.62,16.62,0,0,1,22.72-2.49A15.13,15.13,0,0,1,826.52,407.33Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.65,460.52c-8.46,2.73-38.15-4.07-38.15-4.07s19.39-22.65,27.85-25.39,17.63,1.65,20.47,9.78A15.4,15.4,0,0,1,816.65,460.52Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.14,523.39c-8.74-1.74-30.8-22-30.8-22S761,491.22,769.72,493a15.55,15.55,0,0,1,12.53,18.37C780.44,519.74,771.88,525.14,763.14,523.39Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.51,562.2c-8.92-.3-34.23-16.7-34.23-16.7s26.44-14.66,35.36-14.36,15.9,7.5,15.59,16.07S720.43,562.5,711.51,562.2Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.87,437.45c1.14,8.51,20.47,31.21,20.47,31.21s12.73-26.67,11.59-35.18-9.24-14.52-18.1-13.43S749.73,428.94,750.87,437.45Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.08,483.57c3.74,7.79,29.25,23.89,29.25,23.89s3.85-29.11.11-36.9A16.45,16.45,0,0,0,699,463,15.3,15.3,0,0,0,691.08,483.57Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.37,536.06c2.31,8.29,24.63,28.3,24.63,28.3s8.91-28.06,6.59-36.35-11.17-13.21-19.8-11A15.48,15.48,0,0,0,639.37,536.06Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.52,407.33c-5.55,6.72-34.32,16.52-34.32,16.52s3.47-29.15,9-35.86a16.62,16.62,0,0,1,22.72-2.49A15.13,15.13,0,0,1,826.52,407.33Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.65,460.52c-8.46,2.73-38.15-4.07-38.15-4.07s19.39-22.65,27.85-25.39,17.63,1.65,20.47,9.78A15.4,15.4,0,0,1,816.65,460.52Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.14,523.39c-8.74-1.74-30.8-22-30.8-22S761,491.22,769.72,493a15.55,15.55,0,0,1,12.53,18.37C780.44,519.74,771.88,525.14,763.14,523.39Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.51,562.2c-8.92-.3-34.23-16.7-34.23-16.7s26.44-14.66,35.36-14.36,15.9,7.5,15.59,16.07S720.43,562.5,711.51,562.2Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.87,437.45c1.14,8.51,20.47,31.21,20.47,31.21s12.73-26.67,11.59-35.18-9.24-14.52-18.1-13.43S749.73,428.94,750.87,437.45Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.08,483.57c3.74,7.79,29.25,23.89,29.25,23.89s3.85-29.11.11-36.9A16.45,16.45,0,0,0,699,463,15.3,15.3,0,0,0,691.08,483.57Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.37,536.06c2.31,8.29,24.63,28.3,24.63,28.3s8.91-28.06,6.59-36.35-11.17-13.21-19.8-11A15.48,15.48,0,0,0,639.37,536.06Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.23,494s3.6-72.91,45.24-113.57c17.48-17.07,29.11-38.89,32.45-62.62a179.44,179.44,0,0,0,1.44-34",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.45,258c-2.93,8.1-26.69,26.52-26.69,26.52S739,256,741.9,247.85s12.14-12.4,20.57-9.58A15.4,15.4,0,0,1,772.45,258Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.48,311.36c-7,5.28-37.39,8.33-37.39,8.33s10.47-27.56,17.51-32.83a16.6,16.6,0,0,1,22.69,2.7A15.13,15.13,0,0,1,781.48,311.36Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.69,387.74c-8.85,1.14-36.66-11-36.66-11s23.52-18.71,32.36-19.84,17,4.83,18.17,13.33S761.53,386.6,752.69,387.74Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.36,440.81c-8.52,2.56-38.05-4.85-38.05-4.85s19.89-22.25,28.41-24.81,17.58,2,20.25,10.19A15.44,15.44,0,0,1,717.36,440.81Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.46,310.57c4,7.66,30.08,22.91,30.08,22.91s2.81-29.21-1.2-36.88a16.47,16.47,0,0,0-21.7-6.89A15.25,15.25,0,0,0,711.46,310.57Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671,373.14c6.21,6.16,35.83,13.21,35.83,13.21s-6.41-28.68-12.62-34.84a16.63,16.63,0,0,0-22.86-.34A15.11,15.11,0,0,0,671,373.14Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.29,439.14c5,7.08,33,18.85,33,18.85S672,428.68,667,421.59a16.59,16.59,0,0,0-22.47-4A15.17,15.17,0,0,0,640.29,439.14Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.56,
    cy: 687.61,
    rx: 18.05,
    ry: 2.48,
    fill: "#f6841f",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 331.42,
    cy: 694.62,
    rx: 18.05,
    ry: 2.48,
    fill: "#f6841f",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.98,
    cy: 685.13,
    rx: 18.05,
    ry: 2.48,
    fill: "#f6841f",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.09,
    cy: 714.58,
    rx: 12.83,
    ry: 1.76,
    fill: "#f6841f",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.33,
    cy: 712.82,
    rx: 12.83,
    ry: 1.76,
    fill: "#f6841f",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M386.38,712.77s25.31-83-4-116.22c-21.9-24.86-46.76-21.89-57.89-18.81a20.53,20.53,0,0,0-13.28,11c-3.89,8.4-3.19,22,24.28,37.94,46,26.63,48.87,63.17,48.87,63.17Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328.49,589.51s74.62,23.33,57.89,123.26",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.07,597.87s-10.27,6.93-7,17.33",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M336,604s6.28-6.39,13.92-2.86",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M365.47,636.17s11-5.6,13.88,1.41",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M392.76,647.84s-8.28-.66-8.43,3.3",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M387.4,713.43s-29.64-60.31-37.79-59c-3.86.63-5.65,4.43-6.45,8.26a24.29,24.29,0,0,0,1.61,14.68C349,687,360.28,705.36,387.4,713.43Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M349.83,665.89S381,711,387,713",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 291.62,
    y1: 654.22,
    x2: 298.88,
    y2: 654.22,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 300.32,
    y1: 670.73,
    x2: 311.71,
    y2: 671.22,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 307.25,
    y1: 657.52,
    x2: 306.01,
    y2: 663.45,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 319.36,
    y1: 675.57,
    x2: 319.14,
    y2: 680.96,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M386.52,713.43s29.65-60.31,37.8-59c3.86.63,5.65,4.43,6.45,8.26a24.29,24.29,0,0,1-1.61,14.68C425,687,413.65,705.36,386.52,713.43Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M424.09,665.89S393,711,387,713",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 371.6,
    y1: 654.22,
    x2: 364.34,
    y2: 654.22,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 362.9,
    y1: 670.73,
    x2: 351.52,
    y2: 671.22,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 355.98,
    y1: 657.52,
    x2: 357.21,
    y2: 663.45,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 343.87,
    y1: 675.57,
    x2: 344.09,
    y2: 680.96,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M335.62,727.52a5.18,5.18,0,0,1-1.69-2.55,2.25,2.25,0,0,1,1.18-2.59c1.08-.42,2.24.33,3.12,1.09s1.88,1.62,3,1.46a4.63,4.63,0,0,1-1.43-4.32,1.83,1.83,0,0,1,.4-.87c.6-.65,1.69-.37,2.41.14,2.29,1.61,2.93,4.72,2.94,7.51a13.86,13.86,0,0,0,0-3.09,3.17,3.17,0,0,1,1.17-2.74,3.46,3.46,0,0,1,1.77-.42,3.67,3.67,0,0,1,2.88.82,2.87,2.87,0,0,1-.11,3.53,11.2,11.2,0,0,1-3,2.39,6.56,6.56,0,0,0-2.13,2,1.46,1.46,0,0,0-.16.36h-6.45A18.28,18.28,0,0,1,335.62,727.52Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M448.59,703.23a5.18,5.18,0,0,1-1.69-2.55,2.25,2.25,0,0,1,1.18-2.59c1.08-.42,2.24.33,3.12,1.09s1.88,1.62,3,1.46a4.61,4.61,0,0,1-1.43-4.32,1.83,1.83,0,0,1,.4-.87c.6-.65,1.69-.37,2.41.14,2.29,1.61,2.93,4.72,2.94,7.51a13.86,13.86,0,0,0,0-3.09,3.18,3.18,0,0,1,1.16-2.74,3.49,3.49,0,0,1,1.78-.42,3.68,3.68,0,0,1,2.88.82,2.86,2.86,0,0,1-.12,3.53,11,11,0,0,1-3,2.39,6.43,6.43,0,0,0-2.12,2,1.46,1.46,0,0,0-.16.36h-6.45A18,18,0,0,1,448.59,703.23Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M410.94,727.52a5.18,5.18,0,0,1-1.69-2.55,2.25,2.25,0,0,1,1.18-2.59c1.08-.42,2.24.33,3.12,1.09s1.88,1.62,3,1.46a4.61,4.61,0,0,1-1.43-4.32,1.83,1.83,0,0,1,.4-.87c.6-.65,1.69-.37,2.41.14,2.29,1.61,2.93,4.72,2.94,7.51a13.86,13.86,0,0,0,0-3.09,3.18,3.18,0,0,1,1.16-2.74,3.49,3.49,0,0,1,1.78-.42,3.68,3.68,0,0,1,2.88.82,2.86,2.86,0,0,1-.12,3.53,11,11,0,0,1-3,2.39,6.43,6.43,0,0,0-2.12,2,1.46,1.46,0,0,0-.16.36h-6.45A18,18,0,0,1,410.94,727.52Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M304.16,678.42s-2.42,3.16,1.12,7.93,6.45,8.81,5.27,11.78c0,0-5.33-8.86-9.68-9S299.39,683.75,304.16,678.42Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M304.16,678.42a3.74,3.74,0,0,0-.49,1c-4.24,5-6.49,9.62-2.42,9.73,3.79.11,8.34,6.89,9.43,8.61,0,.13-.08.26-.13.38s-5.33-8.86-9.68-9S299.39,683.75,304.16,678.42Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M299.67,682.45c0,1.11.12,2,.27,2s.28-.9.28-2-.15-.59-.31-.59S299.67,681.33,299.67,682.45Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#ffd037"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.12,683.78c1,.53,1.83.85,1.91.71s-.66-.67-1.64-1.2-.59-.15-.67,0S297.15,683.24,298.12,683.78Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#ffd037"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M316.94,678.42s2.41,3.16-1.12,7.93-6.45,8.81-5.27,11.78c0,0,5.33-8.86,9.67-9S321.71,683.75,316.94,678.42Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M316.94,678.42a4.15,4.15,0,0,1,.49,1c4.23,5,6.49,9.62,2.42,9.73-3.79.11-8.34,6.89-9.43,8.61,0,.13.08.26.13.38s5.33-8.86,9.67-9S321.71,683.75,316.94,678.42Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M321.43,682.45c0,1.11-.12,2-.28,2s-.28-.9-.28-2,.16-.59.31-.59S321.43,681.33,321.43,682.45Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#ffd037"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M323,683.78c-1,.53-1.83.85-1.9.71s.66-.67,1.64-1.2.59-.15.66,0S324,683.24,323,683.78Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#ffd037"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M320.66,697.72s-6.76-.21-8.8-1.66-10.4-3.18-10.9-.85-10.17,11.57-2.53,11.63,17.74-1.19,19.77-2.43S320.66,697.72,320.66,697.72Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#a8a8a8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M298.29,706c7.64.06,17.74-1.19,19.77-2.43,1.55-.94,2.17-4.33,2.38-5.89h.22s-.43,5.45-2.46,6.69-12.14,2.49-19.77,2.43c-2.21,0-3-.8-2.93-2C295.81,705.58,296.65,706,298.29,706Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 230.51,
    y: 568.43,
    width: 17.67,
    height: 39.49,
    rx: 8.83,
    ry: 8.83,
    transform: "translate(673.48 164.95) rotate(72.57)",
    fill: "#f6841f"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M731,314.93s-3.1-23.71-19.75-24.21,2.61,29.41,4.57,32.11c1.15,1.57.23,5.94-.72,9.31a69,69,0,0,0-1.71,7.37,17.21,17.21,0,0,1-3.76,8.53,42.67,42.67,0,0,0-6.7,11.22s-4.9.21-6.69-1-13.22-5.38-13.71-4.71c-.11.14-.42.2-.85.19a13.77,13.77,0,0,1-2-.25c-.09-.56-.19-1.12-.33-1.7,0,0-1.41-.61-3-1.47,0,0,0,0,0-.05l0-.05h0c.37-.94.61-1.95,1-2.87l0-.08h0a4.45,4.45,0,0,1,1.27-1.8c1.53-1.23,3.74-.81,5.59-1.42a6.44,6.44,0,0,0,.61-.24l.22-.13.34-.19.24-.17.27-.2.24-.21a2.39,2.39,0,0,1,.23-.22l.21-.25.21-.24.19-.27c.06-.09.13-.17.18-.26s.12-.19.17-.29l.16-.29.15-.3.13-.31a3.05,3.05,0,0,0,.13-.32c0-.1.07-.21.11-.32s.06-.22.1-.33,0-.21.08-.33a3.38,3.38,0,0,0,.08-.34l.06-.33c0-.12,0-.24.05-.36s0-.21,0-.31l0-.39a2.72,2.72,0,0,1,0-.28c0-.14,0-.28,0-.42v-.22l0-.49s0-.06,0-.09a10,10,0,0,0-.19-1.22c-.46-2-1.37-4.15-.74-5.94a1.67,1.67,0,0,1,.08-.2,3.13,3.13,0,0,1,.3-.57,4.11,4.11,0,0,1,1.66-1.37c.58-.3,1.22-.53,1.82-.78a14,14,0,0,0,5.78-4l0,0a9.24,9.24,0,0,0,2-4.52,7.21,7.21,0,0,0,0-2.27c0-.07,0-.14,0-.21h0a21.18,21.18,0,0,1-.9-4,5.1,5.1,0,0,1,.23-1.57q.12-.36.27-.72l.08-.17c.11-.23.23-.46.35-.68a.75.75,0,0,0,.07-.12l.39-.62.09-.13c.14-.22.3-.44.45-.66.37-.53.76-1.05,1.12-1.59l0,0c.17-.25.33-.51.48-.77l0,0c.15-.27.29-.53.42-.8,0,0,0-.09,0-.13a9,9,0,0,0,.33-.86l.09-.29c.09-.33.17-.65.23-1a2,2,0,0,1,0-.24c0-.3.08-.6.1-.9a1.5,1.5,0,0,1,0-.22c0-.35,0-.7,0-1.06a2.35,2.35,0,0,0,0-.26c0-.35,0-.71-.07-1.06a27.19,27.19,0,0,0-.66-3.73c-.43-1.79-1.19-3.84-2.93-4.32a7.16,7.16,0,0,0-2.72.12,13.06,13.06,0,0,1-8.08-2.05,64.9,64.9,0,0,1-6.85-5.12c-1.52-1.19-3.4-2.37-5.22-1.78a14,14,0,0,0-1.85.94,2.09,2.09,0,0,1-.4.12,9.57,9.57,0,0,1-1.92.16H672c-.55-1.76-1.14-3.5-1.8-5.22-1.67-4.37-3.8-8.76-7.41-11.64a29.85,29.85,0,0,0-6.84-3.73c-7.33-3.2-15.39-6.45-23-4.16-3.37,1-6.36,3-9.29,5L611.37,270l-.92-.28c-1.8-.52-3.66-.83-4.74-1.19l-.19-.06c-3.46-1.29-6.92-4.12-7-7.92a8.51,8.51,0,0,1,.17-1.75,28.14,28.14,0,0,1,1.13-3.55c.25-.68.46-1.37.67-2.06l.2-.74c.12-.44.23-.88.34-1.32l.21-1c.08-.36.14-.71.21-1.07s.14-.76.19-1.14c0-.17,0-.35.08-.53.15-1.09.26-2.18.32-3.27v0c0-.58,0-1.16.06-1.75,0-.08,0-.17,0-.25,0-.59,0-1.18,0-1.77v0h0a41.06,41.06,0,0,0-6.9-21.7,13,13,0,0,0-1.35,5.33,2,2,0,0,1-.2,1,1.3,1.3,0,0,1-1.87.08,18.29,18.29,0,0,1-1.4-1.62,3.44,3.44,0,0,0-4.17-.5,3.78,3.78,0,0,0-1.53,4.05,15.73,15.73,0,0,0-15.71,1,5.82,5.82,0,0,0-2.71,3.44v0a4,4,0,0,0,.47,2.79c.85,1.66,2.5,3.16,3.58,4.86-4.54,5.71-6.54,14.12-6.54,14.12l-.88,1.1a30.9,30.9,0,0,0-5.64,4.47c-1.23,1.34-2.26,3.18-1.88,5l-15.26,19.15s-16.33,22.27-18,27.31c-.34,1-7,8.74,3.09,18.15s12.08,10.42,13.55,13.62c.86,1.87,7.44,5.28,12.77,7.79l1.86.87c-.43,5.54,2.15,12,9.94,19.44a13.4,13.4,0,0,1,.23,2.67c0,6.55,2.94,17.4,2.94,17.4s4.16,6.55-1.22,10.84-6.59,6.76-3.28,10.24l.1.1-.49,9.84h-1.44s-13,9.07-15.7,14.37S536.88,455,536.88,455s-1,13.61-2.45,15.63,0,10.34,0,10.34-.25,12.86,2.93,15.89,2.21,10.59,2.21,10.59a35.79,35.79,0,0,0,.56,4.89c-3.41-1-9.44-1.66-10.48,6.21a84,84,0,0,0-.73,18s-2.94,13.23-5.14,17-6.86,37.24,13.83,31.52c0,0,3.11-.89,5-5.14a23.37,23.37,0,0,0,2.15-2.68c-.08,6.53,1.72,12.05,8.09,10.7,0,0,3.66-.81,5.31-8.51a79.34,79.34,0,0,0,9-10.51l5.91-14.74h0l.45-1.13,5.5-5.9a148.45,148.45,0,0,0,28,5.88,68.89,68.89,0,0,0,8.4.38,64.68,64.68,0,0,0,14.5-1.37c8.92,1.24,24.48,2.26,37.56-2.79,19.58-7.56,6.12-24.21,2.69-27.74s-14.25-14-15.12-14.82l0-.06s2-60.52-2.21-62.28-18.11-16.65-18.11-16.65l1.47-9.58s6.85.76,7.1-5.3,0-15.13,0-15.13l9-16.14s10.9-6.47,15.85-8.66c.26.17.54.35.85.52,5.38,3.08,16.9,6.46,20.92,5.7,5.39-1,16.16,1.35,23,2s10-6.21,9.3-7,2.78-8.51,2.78-8.51,6.53-31.61,5.06-36.65S731,314.93,731,314.93ZM555.16,517.75c.57.28,1.16.55,1.77.82a95.61,95.61,0,0,0,9.82,3.48l6.12,2.27s-9.22.22-13.82.45a13.58,13.58,0,0,1-5.94-2.75A10.2,10.2,0,0,1,555.16,517.75Zm92.47-176.6c-.11-.3-.21-.62-.3-.94.84-.21,1.66-.45,2.48-.72-.55.63-1.22,1.38-2,2.19C647.75,341.5,647.68,341.33,647.63,341.15Zm-103-25S549,305.38,552.36,298q.2.89.45,1.77c-.14,0-.12-.16.46,1.35l0,.08a22.13,22.13,0,0,0,9.2,11,20.38,20.38,0,0,0,4.36,2c0-.05,0-.1,0-.15a1.45,1.45,0,0,0,0-.29,1.1,1.1,0,0,0,0-.18,1.26,1.26,0,0,0,0-.28l-.06-.14a1.51,1.51,0,0,0-.15-.28l-.09-.1a.7.7,0,0,0-.14-.16c.68.43,1.37.84,2.06,1.26.15.08.29.18.44.27.71.41,1.42.8,2.14,1.19l.52.3c.85.45,1.72.89,2.59,1.31l.13.06,1.08.5,1.7.77a3,3,0,0,0,1.78.35,2.84,2.84,0,0,0,1.08-.58l.33-.25c2.07-1.54,4.71-1.94,7.07-2.93s4.71-3.07,4.56-5.7a6.05,6.05,0,0,0-2.62-4.24c-1.35-1-2.91-1.74-4.28-2.74-2.53-1.86-4.29-5.35-3.49-8.25a5.25,5.25,0,0,1,.22-.63l.06-.15q.12-.25.27-.51c0-.05.06-.11.1-.17a6.56,6.56,0,0,1,1.14-1.27,19,19,0,0,1,1.78-1.32l12.06-8.13c.91-.62,1.82-1.23,2.76-1.8l0,0a27.35,27.35,0,0,1,2.49-1.36c.25-.11.5-.23.76-.33l.5-.21c.45-.17.9-.33,1.37-.47.25-.06.59-.12,1-.18A65.37,65.37,0,0,1,600.84,289a9,9,0,0,0-.94,2.07,2.6,2.6,0,0,0-.11.62,6.18,6.18,0,0,0,.56,2.6c.7,1.88,1,3.28,2.59,4.4.42.3.81.58,1.15.87,0,.3-.09.6-.13.9a38.88,38.88,0,0,0-.26,4.47,36.89,36.89,0,0,0,7,21.69l-.4.45a36.64,36.64,0,0,1-7.37,6.55c-.32.2-.64.39-1,.57a11.29,11.29,0,0,1-1.17-2.55,3.14,3.14,0,0,1-4-1.76c-1.42-2.78-5.83,0-5.83,0s-10-5.8-10.52-3.28a2.51,2.51,0,0,1-.57,1.06l-.59-.56s-2.3.76-5.53,2.24a6.2,6.2,0,0,1-3.6-2.24c-1-1.3-.74.62-.11,4.08l-.08.05-1.17-.43C561.85,328.26,545.41,321.66,544.64,316.1Zm112.92,25.16c-.45-1.41-2.63-2.51-4.26-3.16A36,36,0,0,0,671.46,319c.15-.37.29-.75.43-1.13.29-.07.58-.12.86-.21a4.23,4.23,0,0,0,2.86-2.1,4.71,4.71,0,0,0,.29-1.59c.08-1.21.13-2.42.16-3.63v-.17a90,90,0,0,0-2.21-22.07l1.08.89h0c.42.35.84.7,1.25,1.06s.71.65,1,1l.16.16c.32.32.63.65.92,1a1.13,1.13,0,0,1,.1.13,11.86,11.86,0,0,1,.73,1l.25.39q.29.46.54,1l.1.2a10,10,0,0,1,.4,1.08l.09.25c.09.32.16.64.23,1,0,.15.07.29.1.44.06.34.1.69.14,1.05,0,.12,0,.25,0,.38,0,.33.05.67.07,1s0,.43,0,.64a44.92,44.92,0,0,1-4.1,19.53,76.29,76.29,0,0,1-10.63,16.85,22.41,22.41,0,0,0-3.51,5.16,10.41,10.41,0,0,0-.39,1.11C660.66,343.19,658,342.7,657.56,341.26Z",
    transform: "translate(-55.35 -18.71)",
    fill: "url(#96fd64a0-6351-4330-b812-2613840b356c)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M734.67,331.17c1.5,5-5.17,36.33-5.17,36.33s-3.5,7.71-2.83,8.44-2.5,7.56-9.5,6.89-18-3-23.5-2c-4.11.75-15.87-2.6-21.37-5.65-1.87-1-3-2.05-2.9-2.85.43-3.16,10.93-17.5,10.93-17.5a29.35,29.35,0,0,0,4.8.86c.44,0,.76-.05.87-.19.5-.67,12.17,3.5,14,4.67s6.83.95,6.83.95A42.17,42.17,0,0,1,713.67,350a16.87,16.87,0,0,0,3.85-8.46,65.8,65.8,0,0,1,1.74-7.31c1-3.34,1.91-7.67.74-9.23-2-2.67-21.67-32.33-4.67-31.83s20.17,24,20.17,24S733.17,326.17,734.67,331.17Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#fbbebe"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M658,359.25l-14,6-16.25,5S590.5,340,600,337.75a16.26,16.26,0,0,0,4.68-2,36.94,36.94,0,0,0,7.53-6.49,66.24,66.24,0,0,0,6.54-8.47s36.75-1.75,31,7c-2.24,3.41-1.48,8.95.28,14.44.1.33.21.66.32,1A92.51,92.51,0,0,0,658,359.25Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#fbbebe"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M565.92,527.61s-6.45-6-8.8,3.24A95,95,0,0,0,554.34,546s-3.56,10.89-5.44,13.88-9.11,30.8,4.7,28c0,0,5.08-1.08,6.07-12.81s9.53-46.72,9.53-46.72Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M670.75,549.5c-14,5.24-30.74,3.89-39.59,2.6-3.82-.55-6.16-1.1-6.16-1.1l-43.75-4.5-.88.92-5.62,5.85L568.25,569s-17.5,24-19.5,9.75a58.58,58.58,0,0,1-.37-9.4c.4-15.19,4.37-35.35,4.37-35.35l39.75-5.25,25-13,.27-13.56.06-3.33.17-8.36,34,3.25,6,13.5.06.06c.88.82,12.08,11.33,15.44,14.69S690.75,542,670.75,549.5Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#fbbebe"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M574.29,554.39s-17.85.75-19-2.45l-5.53,13.19s16.25,6.25,18.5,3.87Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M543,513.75S531.38,508,529.88,519a81.1,81.1,0,0,0-.75,17.88s-3,13.12-5.25,16.87-7,36.92,14.12,31.25c0,0,7.75-2.12,6.5-15.75S548.34,514,548.34,514Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M607.25,487.75l36.25,32s21,11.25-4,30.5c0,0-11.25,4.75-28.5,3a153,153,0,0,1-31.5-6.75s-13-2-17.5,5-14.5,22.25-14.5,22.25S535.25,598,527.25,568l10.25-29.25s.5-9.75,0-12,6.75-12.25,10.5-9,8.75,7.75,13,7.5,15-.5,15-.5l-6.25-2.25s-18-5-16.75-8.75,10-22,10-22Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M637.5,550.25a39.64,39.64,0,0,1-6.34,1.85A70.18,70.18,0,0,1,609,553.25a156.08,156.08,0,0,1-28.63-5.83c-1.84-.56-2.87-.92-2.87-.92s-13-2-17.5,5c-3,4.61-8.31,12.79-11.62,17.85l-2.88,4.4S533.25,598,525.25,568l10.25-29.25s.5-9.75,0-12c-.34-1.53,2.89-6.62,6.17-8.71,1.55-1,3.12-1.34,4.33-.29a49.2,49.2,0,0,0,8,6.09,9.58,9.58,0,0,0,5,1.41c4.25-.25,15-.5,15-.5l-6.25-2.25a97.89,97.89,0,0,1-10-3.45c-3.89-1.64-7.29-3.6-6.72-5.3,1.25-3.75,10-22,10-22l44.25-4,12.58,11.11,5.39,4.75,18.28,16.14S662.5,531,637.5,550.25Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#fbbebe"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M606,534s-9.5-12.75-32-9.25",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M534.5,536.63l-7.25,16.62s8,18.38,23.5,15.63l9.53-17.27S538.76,549.37,534.5,536.63Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M533.5,537.63l-7.25,16.62s8,18.38,23.5,15.63l9.53-17.27S537.76,550.37,533.5,537.63Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M675.25,374a17.89,17.89,0,0,0-3,1.18c-1.87-1-3-2.05-2.9-2.85.43-3.16,10.93-17.5,10.93-17.5a29.35,29.35,0,0,0,4.8.86C686.77,366.76,678.32,373.29,675.25,374Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M658,360.25l-14,6-16.25,5S590.5,341,600,338.75a16.26,16.26,0,0,0,4.68-2c5.6,7.36,18.82,15,18.82,15,11.06,4,21.11-3.3,26.53-8.56A90.44,90.44,0,0,0,658,360.25Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M673.25,374c-3.25.75-18,9.25-18,9.25l-9.25,16s.25,9,0,15-7.25,5.25-7.25,5.25l-.34.14c-1.79.75-10.19,4.28-10.19,4.36S611,422.25,611,422.25l-33.75-5.5s-10.75-.5-14.25-4l-.1-.1c-3.38-3.45-2.1-5.94,3.35-10.15s1.25-10.75,1.25-10.75-3-10.75-3-17.25-3.25-6.25-3.25-6.25-2.25,0,7.75-6.5-1.25-36.75,2.25-32.5,10,2,10.5-.5S592.5,332,592.5,332s4.5-2.75,6,0a3.26,3.26,0,0,0,4,1.75c2.5,8.25,21,19,21,19,16.5,6,30.75-13.25,30.75-13.25s5.5,1.5,6.25,3.77,7,2.16,7,2.16,7.5.82,7.75,3.07,7.5,5.25,7.5,5.25C685.75,366,676.5,373.25,673.25,374Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M638.75,417.5l-.34,2.14c-1.79.75-10.19,4.28-10.19,4.36S611,422.25,611,422.25l-33.75-5.5s-10.75-.5-14.25-4l-.1-.1.1-1.9,5.5-1s54,3,61.5,6.5Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M658.06,507.31c0,1.24-.06,1.94-.06,1.94S647.5,493,633.75,501a17.63,17.63,0,0,1-10.53,2.61,16.67,16.67,0,0,1-5.45-1.42,21.52,21.52,0,0,1-7.52-5.69s-24,5-32.25,11.75-15-2-15-2-2.35,10.27-5.28,12.8c-3.89-1.64-7.29-3.6-6.72-5.3,1.25-3.75,10-22,10-22l44.25-4,12.58,11.11.17-8.36,34,3.25,6,13.5Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M568.5,411.75s54,3,61.5,6.5l8.75,1.25-1.5,9.5s14.25,14.75,18.5,16.5S658,507.25,658,507.25,647.5,491,633.75,499s-23.5-4.5-23.5-4.5-24,5-32.25,11.75-15-2-15-2-2.75,12-6,13.25-4,9.25-4,9.25-9-1.75-9-4.5-.25-3.75-2-5.75-2-8.5-2-8.5,1-7.5-2.25-10.5-3-15.75-3-15.75-1.51-8.25,0-10.25,2.5-15.5,2.5-15.5,5-14,7.75-19.25,16-14.25,16-14.25h1.47l.5-9.75Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 572.98,
    cy: 412.54,
    r: 1.58,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.56,
    cy: 448.38,
    r: 1.58,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.65,
    cy: 436.21,
    r: 1.58,
    fill: "#3f3d56"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M565.33,424h2s-12,27.5-12.66,19.83S565.33,424,565.33,424Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M579.67,426s-13.67,21-7,24,12.66-23,12.66-23Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M597.83,438.12s5.17,31.88,11,38.05-1,10.5-1,10.5,20.5,1.83,27,3.16,16.5-1.5,12.5-4.16-.66-31-.33-32.34S634.17,477.91,597.83,438.12Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M575.67,400.67c1.16-.5,19.83-26.72,24.33-24.61S575.67,400.67,575.67,400.67Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M578,377.5s-7.5,11.5-5.33,13.5S578,377.5,578,377.5Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M588.07,334s7.6,15.17,5.43,18S588.07,334,588.07,334Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M673.33,354.83s-1.5,8.84-3.5,9.17S673.33,354.83,673.33,354.83Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M637.33,357.67s21.17,5.18,22.84,6.34S641.83,365.17,637.33,357.67Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M715.33,372.67s-2.66-10.34-6.16-10.17S715.33,372.67,715.33,372.67Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M706.1,305.37c-1.3,2.69-4.13,4.84-4.09,7.83,0,1.42.71,2.73,1,4.13a8.34,8.34,0,0,1-2,6.72,14.33,14.33,0,0,1-5.93,4c-1.31.51-2.76,1-3.56,2.13-1.31,1.89-.17,4.41.37,6.65.86,3.61-.56,8.12-4.09,9.24-1.89.6-4.15.19-5.71,1.4s-1.72,3.63-2.69,5.43a6.22,6.22,0,0,1-8.14,2.44,6.29,6.29,0,0,1,.35-2.72,5.12,5.12,0,0,1-5.71-2.33,6.82,6.82,0,0,1,.05-6,22.48,22.48,0,0,1,3.58-5.12,75.42,75.42,0,0,0,10.86-16.7,43.46,43.46,0,0,0,4.19-19.36,14.81,14.81,0,0,0-1.13-5.78,14.34,14.34,0,0,0-3.94-4.78c-.83-.72-1.71-1.4-2.57-2.09-.6-.48-1.2-1-1.77-1.46-.78-.69-3.88-3.22-3.63-4.44.14-.7,2.24-.6,4.07-.62a9.93,9.93,0,0,0,2-.16,2,2,0,0,0,.41-.12,15.75,15.75,0,0,1,1.89-.93c1.86-.58,3.78.59,5.33,1.77a66.21,66.21,0,0,0,7,5.07,13.68,13.68,0,0,0,8.25,2,7.47,7.47,0,0,1,2.78-.12c1.77.47,2.55,2.5,3,4.28C707,298.91,707.52,302.41,706.1,305.37Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M608,279.9a10.32,10.32,0,0,0-1.14.2,18.43,18.43,0,0,0-3.08,1.17,45.06,45.06,0,0,0-5,3l-12.32,8.06a10.15,10.15,0,0,0-3,2.58c-2.09,3.07-.13,7.46,2.9,9.62,1.4,1,3,1.7,4.37,2.72a6,6,0,0,1,2.68,4.2c.15,2.61-2.25,4.66-4.66,5.65s-5.11,1.38-7.22,2.91a4.16,4.16,0,0,1-1.44.82,3.16,3.16,0,0,1-1.82-.35,75.56,75.56,0,0,1-10.88-5.61,1.47,1.47,0,0,1,.45,1.57,21.72,21.72,0,0,1-12.41-31.65c1.29-2.21,3-4.2,4-6.53s1.38-5.22,0-7.35c-1-1.49-2.75-2.49-3.27-4.2s.56-3.76,1.87-5.15c2.89-3,6.88-4.8,10.07-7.54s5.6-7.28,3.79-11.07c-1.44-3-5.31-5.23-4.66-8.5A5.79,5.79,0,0,1,570,231a16.47,16.47,0,0,1,16-1,3.69,3.69,0,0,1,1.57-4,3.59,3.59,0,0,1,4.26.49,18.35,18.35,0,0,0,1.42,1.61,1.37,1.37,0,0,0,1.91-.08,1.88,1.88,0,0,0,.21-1,12.56,12.56,0,0,1,1.38-5.29,40.21,40.21,0,0,1,4.73,36.31,14.33,14.33,0,0,0-1.33,5.25c.11,3.77,3.64,6.57,7.18,7.85l.19.06c1.11.36,3,.67,4.84,1.18,2.42.67,4.75,1.69,5,3.6C617.9,279.09,611.16,279.47,608,279.9Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M556.5,293.83c-1.83,2-11.33,24.5-11.33,24.5.79,5.51,17.58,12.06,24.69,14.59,1.92.69,3.14,1.08,3.14,1.08l6.83,6s-7,38.67-7.56,29.17-12.94-14.34-12.94-14.34-3.24-1.32-7.12-3.11c-5.44-2.49-12.16-5.87-13-7.72-1.5-3.17-3.5-4.17-13.84-13.5s-3.5-17-3.16-18c1.66-5,18.33-27.07,18.33-27.07L564.67,256s6.66-27.33,23.4-16.67S569,275.5,569,275.5,558.33,291.83,556.5,293.83Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#fbbebe"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M579.83,340s-7,38.67-7.56,29.17-12.94-14.34-12.94-14.34-3.24-1.32-7.12-3.11c1.25-8.86,10.47-15.17,17.65-18.8,1.92.69,3.14,1.08,3.14,1.08Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M587.9,335.93l-7.33-6.68s-47.42,15-15.42,43.42h13.49L591,356.25Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M650,342.19c.1.33.21.66.32,1a36.05,36.05,0,0,1-38.14-13.95,66.24,66.24,0,0,0,6.54-8.47s36.75-1.75,31,7C647.51,331.16,648.27,336.7,650,342.19Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M677.49,307.27a36,36,0,1,1-36-36A35.86,35.86,0,0,1,677.49,307.27Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#fbbebe"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M677.49,307.27a35.86,35.86,0,0,1-2.8,13.93,16.21,16.21,0,0,1-6.13.1,3.63,3.63,0,0,1-2.17-1,4,4,0,0,1-.73-2q-.57-3.33-1.12-6.64c-3.24,1.27-7,.33-10-1.37s-5.64-4.07-8.56-6-6.41-3.3-9.84-2.68a16.64,16.64,0,0,0-5.26,2.21,36.77,36.77,0,0,0-9,6.73c-1.82,2-3.41,4.4-5.93,5.31a6.28,6.28,0,0,1-7.83-4c-.53-1.85-.17-3.83-.39-5.74a4.46,4.46,0,0,0-1.91-3.32,36,36,0,0,1,71.73,4.43Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M607.67,305.16c.22,1.91-.14,3.89.39,5.74a6.28,6.28,0,0,0,7.83,4c2.52-.91,4.11-3.33,5.93-5.31a36.77,36.77,0,0,1,9-6.73,16.64,16.64,0,0,1,5.26-2.21c3.43-.62,6.91.79,9.84,2.68s5.52,4.27,8.56,6,6.77,2.64,10,1.37l1.12,6.64a4,4,0,0,0,.73,2,3.63,3.63,0,0,0,2.17,1,16.19,16.19,0,0,0,7.45-.43,4.28,4.28,0,0,0,2.92-2.08,4.67,4.67,0,0,0,.3-1.58,86.71,86.71,0,0,0-5.78-37.48c-1.71-4.34-3.89-8.69-7.57-11.54a30.56,30.56,0,0,0-7-3.7c-7.48-3.17-15.72-6.4-23.53-4.13-3.44,1-6.49,3-9.49,5l-14,9.29a8.74,8.74,0,0,0-2,1.65,9.54,9.54,0,0,0-1.51,3.3,64,64,0,0,1-5.74,12.88,6.39,6.39,0,0,0-1.08,2.67,6.1,6.1,0,0,0,.58,2.57c.72,1.87,1,3.26,2.64,4.36S607.41,303,607.67,305.16Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.76,314.07c-2.41,1-5.11,1.38-7.22,2.91a4.16,4.16,0,0,1-1.44.82,3.16,3.16,0,0,1-1.82-.35,74.78,74.78,0,0,1-11-5.71,1.45,1.45,0,0,1,.6,1.67A22.06,22.06,0,0,1,554,300.58c-.8-2.05.15,2.19,0,0-.22,3.19-1.16,0,0,3a22.06,22.06,0,0,0,13.84,12.83,1.45,1.45,0,0,0-.6-1.67,74.78,74.78,0,0,0,11,5.71,3.16,3.16,0,0,0,1.82.35,4.16,4.16,0,0,0,1.44-.82c2.11-1.53,4.81-1.93,7.22-2.91s4.81-3,4.66-5.65a4.2,4.2,0,0,0-.29-1.27A7.77,7.77,0,0,1,588.76,314.07Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.17,260.3a6,6,0,0,0,.18,1.27,25.84,25.84,0,0,1,1.15-3.52,39,39,0,0,0,2.31-14.8,38.69,38.69,0,0,1-2.31,11.8A14.33,14.33,0,0,0,600.17,260.3Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.46,294.29c-1.34-2.87-3.88-4.78-6.33-6.72.28,1.19.53,2.39.76,3.6,2.2,1.74,4.37,3.55,5.57,6.12a14.48,14.48,0,0,1,1.12,5.49c0-.9,0-1.8,0-2.71A14.81,14.81,0,0,0,683.46,294.29Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.43,242.14c.3-1.47,1.1-.83.44-2.22-1.09-2.26-3.55-4.08-4.42-6.24a3.76,3.76,0,0,0-.24.74c-.65,3.27,2.78,4.71,4.22,7.72C571.64,242.57,570.54,240,571.43,242.14Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.85,276.92a7.36,7.36,0,0,0-1,.18,28.9,28.9,0,0,0-8.08,4.14l-12.32,8.06a10.15,10.15,0,0,0-3,2.58,5.45,5.45,0,0,0-.67,4.47,4.75,4.75,0,0,1,.67-1.47,10.15,10.15,0,0,1,3-2.58l12.32-8.06a29.53,29.53,0,0,1,7.86-4.07C607.06,279.09,607.47,278,607.85,276.92Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.94,317.11a9.14,9.14,0,0,1-1.92,3.94,14.33,14.33,0,0,1-5.93,4c-1.31.51-2.76,1-3.56,2.13a4.63,4.63,0,0,0-.39,3.77,3.1,3.1,0,0,1,.39-.77c.8-1.16,2.25-1.62,3.56-2.13a14.33,14.33,0,0,0,5.93-4,8.34,8.34,0,0,0,2-6.72C703,317.25,703,317.18,702.94,317.11Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.1,302.37c-1.3,2.69-4.13,4.84-4.09,7.83a5.78,5.78,0,0,0,.23,1.48c.69-2.25,2.79-4.1,3.86-6.31a11,11,0,0,0,.81-6A9.37,9.37,0,0,1,706.1,302.37Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.39,319.3a3.63,3.63,0,0,0,2.17,1,16.19,16.19,0,0,0,7.45-.43,4.28,4.28,0,0,0,2.92-2.08,4.67,4.67,0,0,0,.3-1.58c.17-2.46.22-4.92.17-7.38,0,1.46-.07,2.92-.17,4.38a4.67,4.67,0,0,1-.3,1.58,4.28,4.28,0,0,1-2.92,2.08,16.19,16.19,0,0,1-7.45.43,3.63,3.63,0,0,1-2.17-1,4,4,0,0,1-.73-2q-.57-3.33-1.12-6.64c-3.24,1.27-7,.33-10-1.37s-5.64-4.07-8.56-6-6.41-3.3-9.84-2.68a16.64,16.64,0,0,0-5.26,2.21,36.77,36.77,0,0,0-9,6.73c-1.82,2-3.41,4.4-5.93,5.31a6.28,6.28,0,0,1-7.83-4c-.53-1.85-.17-3.83-.39-5.74-.26-2.18-1.35-3-3-4.08s-1.92-2.49-2.64-4.36c-.09-.24-.19-.5-.27-.75a3.75,3.75,0,0,0-.31,1.18,6.1,6.1,0,0,0,.58,2.57c.72,1.87,1,3.26,2.64,4.36s2.7,1.9,3,4.08c.22,1.91-.14,3.89.39,5.74a6.28,6.28,0,0,0,7.83,4c2.52-.91,4.11-3.33,5.93-5.31a36.77,36.77,0,0,1,9-6.73,16.64,16.64,0,0,1,5.26-2.21c3.43-.62,6.91.79,9.84,2.68s5.52,4.27,8.56,6,6.77,2.64,10,1.37q.56,3.32,1.12,6.64A4,4,0,0,0,666.39,319.3Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.81,343.07c-1.89.6-4.15.19-5.71,1.4s-1.72,3.63-2.69,5.43a6.22,6.22,0,0,1-8.14,2.44,6.29,6.29,0,0,1,.35-2.72,5.12,5.12,0,0,1-5.71-2.33,5.24,5.24,0,0,1-.51-1.31,6.15,6.15,0,0,0,.51,4.31,5.12,5.12,0,0,0,5.71,2.33,6.29,6.29,0,0,0-.35,2.72,6.22,6.22,0,0,0,8.14-2.44c1-1.8,1.07-4.17,2.69-5.43s3.82-.8,5.71-1.4c3.33-1.06,4.78-5.12,4.21-8.61C691.62,340,690.2,342.31,687.81,343.07Z",
    transform: "translate(-55.35 -18.71)"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M612.38,272.39A35.92,35.92,0,0,1,608,279.9a10.32,10.32,0,0,0-1.14.2,18.43,18.43,0,0,0-3.08,1.17,62.45,62.45,0,0,1,3.77-10.06C608.65,271.57,610.54,271.88,612.38,272.39Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M679.52,292.51c-.83-.72-1.71-1.4-2.57-2.09-.5-2-1-4.39-1.33-6.52a9.93,9.93,0,0,0,2-.16A27.53,27.53,0,0,1,679.52,292.51Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.72,436.35c.31-.15.61-.3.91-.47-.61-.12-1.22-.26-1.82-.41-.43.12-.87.21-1.31.31a49.27,49.27,0,0,1-22-13.27c-6.1-6.43-10.37-14.85-10.28-23.6.07-6.38,2.41-12.6,2.34-19s-3.79-13.61-10.31-14.33c-2.27-.25-4.54.34-6.83.42s-4.84-.52-6-2.41c-1-1.63-.74-3.75-.1-5.56,1.74-4.89,5.65-8.84,7.33-13.75a16.52,16.52,0,0,0,.45-9.06c-.58-2.5-1.91-5-4.24-6.21-3.86-2-8.45.32-12.74,1.13-7.34,1.4-14.79-1.79-21.11-5.69s-12.24-8.64-19.35-10.93a46.57,46.57,0,0,0-14.36-1.86c-3,0-6.25.24-8.46,2.19-.11.1-.19.21-.3.31a7.72,7.72,0,0,1,.87-1.75,6.22,6.22,0,0,0-.93.69c-4.59,4.05-1.38,11.78-4.08,17.2a9,9,0,0,1-1.1,1.68,13.21,13.21,0,0,0,1.78-1.64c-.1.24-.19.48-.31.72-1.55,3.12-4.83,5-8,6.54s-6.62,2.95-8.91,5.6c-.06.06-.1.12-.16.19a9.8,9.8,0,0,1,1.6-2.64,13.14,13.14,0,0,0-1.81,1.69c-2.51,2.91-2.7,5.33-1.58,7.19.8,2.13,3.24,3.64,6.09,4.43-.14.63-.27,1.26-.38,1.9a31.62,31.62,0,0,0-.38,4.8c0,14.76,10.62,27.11,24.84,30.24,0,.64-.08,1.29-.16,2-.48,4.54-1.88,9.46-5.55,10.66-3.43-1.17-10.3,4-11.84,5.5s-7,.16-12,.33-6.69-1.33-6.69-1.33a28.46,28.46,0,0,0-.18,8.16c.52,5-3.6,5.17-3.6,5.17s.86,7.17-1,10.83a12.15,12.15,0,0,0-1.37,6.85s5.83-.5,5.31,1.5a1.78,1.78,0,0,0,.34,1.33l-.06,1.91-.79,26.42-1.54,15.75a2.66,2.66,0,0,0-1.72,1.58c-1.39,3.16-3.63,7.37-5.39,10.59-7.15,4.33-17.89,12.36-14.85,20.08,4.46,11.34,10.81,9.84,14.58,8.5S867.08,515,867.08,515s2.23-4.17,3.94-4.17a22.18,22.18,0,0,0,2.73-.29c0,.18,0,.29,0,.29s-3.6,14.17-2.4,17.67.17,8,.17,8-1,10.33.34,13.67S870,562.48,870,562.48s.92.28,2.51.67c-.12.57-.26,1.2-.41,1.9-2.1,9.93-5.87,32.6-1.58,51.26,0,0,2.4,10,2.74,12.68s2.4,5,1,11S877,657,877,657s2.06,10.5.86,15.33,12.52,59,12.52,59l2.24-.32.5,1.93,2.23,8.6.24.94a7.4,7.4,0,0,0-4,2.52s-6,13.67-13.55,17.5c-2,1-4.45,2.34-6.81,3.79-6.74,4.12-12.52,9.08-2.7,9.21,10.76.14,28.44.71,34.78.92,1.35.73,3.62,1.15,7.15,1.08,17.66-.33,42.71-2.17,43.23-3.83.25-.81-.8-2.53-1.94-4.08s-2.53-3.09-2.53-3.09l-.51-15.17s-1.44-1.3-3.67-3.09l-.08-1.06-1.12-14.63-.15-2a5.77,5.77,0,0,0,2.1-.91L947,714.49s7.37-25.33-2.06-50.17c0,0-8.23-17.16-6-23.33l.35-13.17s3.94-15.51,5.83-19.67A106.58,106.58,0,0,0,951,588.27c6.77-10.74,5.66-25,5.66-25l4.8-15,6.69-19.16s1.89-11.67,2.58-14,0-15,0-15,5.8-46.2.95-64.25l0-.69.05,0s0-.38,0-1c.08-.09,5.28-5.51,2.9-7-2-1.24-5.59-6.78-8.33-10.09-.37-.43-.71-.82-1-1.17a34.29,34.29,0,0,0,8.25-9.16c.84-1.37,1.87-3,3.51-3.07a4.43,4.43,0,0,1,2.45.81c12.57,7.53,14.59,26.36,27.84,32.69a19.78,19.78,0,0,0,17.69-.51ZM923.16,737.49l-.11,1a5.4,5.4,0,0,0-1.25.62s-1.72,8.83-2.75,9.5a8.28,8.28,0,0,0-1.27,2.24l-.25-.45c-.08.18-.17.36-.25.55l-.46-.84-.13-1L913.83,727c-.24-3.23-.94-13.93.08-19.55,1.2-6.67,1-30-6.69-39.33,0,0-3.6-8.5-.34-14l.51-34.68,1.2-1.17.17,32a32.27,32.27,0,0,0,7.72,18.34l1.21,16.83s1,18.33,4.11,28.5v15.67s.83.14,2.16.33l-.21,2Z",
    transform: "translate(-55.35 -18.71)",
    fill: "url(#65aaeda9-82be-4b39-9919-e403ba36e3f2)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M943.5,403.17l-7.17,16-2.65,1.55-17.85,10.45s-22.5-2.17-23.16-2.5-1.72-19.44,4.1-23.46a3.84,3.84,0,0,1,1.05-.53h0c3.57-1.2,4.93-6.12,5.4-10.66.07-.67.12-1.32.15-2a47.41,47.41,0,0,0,0-6.38s5.46-5.46,12-11.11c11.59-10,26.58-20.55,20.83-2.56a60.08,60.08,0,0,0-2.34,9.94c-.12.79-.2,1.56-.26,2.29-.7,8.86,2.07,13.64,4.86,16.18.3.28.61.52.91.75A11,11,0,0,0,943.5,403.17Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#cf6f80"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "861.48 732.46 858.98 733.62 842.15 729.79 840.65 723.83 838.48 715.23 836.98 709.29 858.57 709.29 861.35 731.42 861.48 732.46",
    fill: "#cf6f80"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M914.33,752.33,897.5,748.5l-1.5-6c6.38-1.91,15.67,3.46,15.67,3.46-.61,2.12,4.18,3.84,5,4.13l.13,1Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M922.33,760.5l-12.07,11.83L906,776.5l-2.31-.08c-4.35-2.44,1.29-8.37,5.06-11.66.74-.65,1.41-1.19,1.92-1.59,2.7-2.11,5.23-8.12,6.85-11.71Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M917.52,751.46l4.81,9-12.07,11.83L906,776.5l-2.31-.08c-4.35-2.44,1.29-8.37,5.06-11.66.74-.65,1.41-1.19,1.92-1.59C913.37,761.06,915.9,755.05,917.52,751.46Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M944.5,752.33l-22.17-7.5.66-6.33c5.78-2,15.83,5.27,21.2,9.68Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M922.33,761.5l-12.07,11.83L906,777.5s-23.17-.83-36.07-1c-9.54-.13-3.93-5.09,2.62-9.21,2.3-1.45,4.71-2.79,6.62-3.79,7.33-3.83,13.16-17.5,13.16-17.5,5.5-7,19.34,1,19.34,1-.67,2.33,5.16,4.17,5.16,4.17Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M910.26,773.33,906,777.5s-23.17-.83-36.07-1c-9.54-.13-3.93-5.09,2.62-9.21,3.53.8,7.08,2.5,8.28,6Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "889.15 733.62 866.98 726.12 867.64 719.79 868.21 714.26 868.98 706.79 887.15 706.79 887.75 714.84 888.84 729.47 889.15 733.62",
    fill: "#cf6f80"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M952.67,774.67c-.5,1.66-24.84,3.5-42,3.83-14.9.29-6.83-8.46-1.92-12.74.74-.65,1.41-1.19,1.92-1.59,3.83-3,7.33-13.84,8.33-14.5s2.67-9.5,2.67-9.5c7.5-5.34,26.16,12.16,26.16,12.16l.5,15.17s1.28,1.45,2.46,3.09S952.91,773.86,952.67,774.67Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M952.67,774.67c-.5,1.66-24.84,3.5-42,3.83-14.9.29-6.83-8.46-1.92-12.74a22.1,22.1,0,0,1,9.42,7.57h19.16s9.24-1.34,13.46-2.74C951.89,772.14,952.91,773.86,952.67,774.67Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M913.79,728c.11,1.83.21,3,.21,3l-20.17,2.94-1.5-5.94Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M943.1,733.55c-4.93,1.37-15.28.05-19.54-.58l.77-7.47H942.5Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M944.17,665.33c9.16,24.84,2,50.17,2,50.17L945,730.67c-4.17,3.33-23.33,0-23.33,0V715c-3-10.17-4-28.5-4-28.5l-1.17-16.83a32.8,32.8,0,0,1-7.5-18.34l-.17-32-1.16,1.17-.5,34.67c-3.17,5.5.33,14,.33,14,7.5,9.33,7.67,32.66,6.5,39.33s0,20.5,0,20.5l-22.83,3.33s-13.34-54.16-12.17-59-.83-15.33-.83-15.33-4-11-2.67-17-.67-8.33-1-11-2.67-12.67-2.67-12.67c-4.16-18.66-.5-41.33,1.54-51.26.65-3.19,1.13-5.07,1.13-5.07s62-18,72.5-3a21.54,21.54,0,0,1,2.84,5.91c5.13,16.21-3.89,41.58-5.51,45.26-1.83,4.16-5.66,19.66-5.66,19.66L938.33,642C936.17,648.17,944.17,665.33,944.17,665.33Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 872.81,
    cy: 671.46,
    r: 0.67,
    fill: "#f6841f"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 839.63,
    cy: 688.18,
    r: 0.67,
    fill: "#f6841f"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.31,
    cy: 677.63,
    r: 0.67,
    fill: "#f6841f"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.89,
    cy: 678.46,
    r: 0.67,
    fill: "#f6841f"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 839.93,
    cy: 684.11,
    r: 0.67,
    fill: "#f6841f"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.98,
    cy: 682.46,
    r: 0.67,
    fill: "#f6841f"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.98,
    cy: 686.29,
    r: 0.67,
    fill: "#f6841f"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.48,
    cy: 681.79,
    r: 0.67,
    fill: "#f6841f"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 874.15,
    cy: 679.13,
    r: 0.67,
    fill: "#f6841f"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.96,
    cy: 674.56,
    r: 0.67,
    fill: "#f6841f"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.52,
    cy: 678.46,
    r: 0.67,
    fill: "#f6841f"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 842.96,
    cy: 695.38,
    r: 0.67,
    fill: "#f6841f"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.26,
    cy: 703.46,
    r: 0.67,
    fill: "#f6841f"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.81,
    cy: 706.28,
    r: 0.67,
    fill: "#f6841f"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 848.29,
    cy: 706.79,
    r: 0.67,
    fill: "#f6841f"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 844.29,
    cy: 710.6,
    r: 0.67,
    fill: "#f6841f"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.63,
    cy: 683.44,
    r: 0.67,
    fill: "#f6841f"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.63,
    cy: 691.63,
    r: 0.67,
    fill: "#f6841f"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.86,
    cy: 697.02,
    r: 0.67,
    fill: "#f6841f"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 848.02,
    cy: 699.45,
    r: 0.67,
    fill: "#f6841f"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 840.29,
    cy: 710.6,
    r: 0.67,
    fill: "#f6841f"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 852.15,
    cy: 700.86,
    r: 0.67,
    fill: "#f6841f"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.98,
    cy: 676.96,
    r: 0.67,
    fill: "#f6841f"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 877.4,
    cy: 686.29,
    r: 0.67,
    fill: "#f6841f"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 872.81,
    cy: 700.12,
    r: 0.67,
    fill: "#f6841f"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.31,
    cy: 709.29,
    r: 0.67,
    fill: "#f6841f"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 879.15,
    cy: 680.46,
    r: 0.67,
    fill: "#f6841f"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.73,
    cy: 690.29,
    r: 0.67,
    fill: "#f6841f"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.73,
    cy: 697.69,
    r: 0.67,
    fill: "#f6841f"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 868.23,
    cy: 705.22,
    r: 0.67,
    fill: "#f6841f"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 874.15,
    cy: 702.79,
    r: 0.67,
    fill: "#f6841f"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 872.15,
    cy: 704.79,
    r: 0.67,
    fill: "#f6841f"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.98,
    cy: 701.88,
    r: 0.67,
    fill: "#f6841f"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.98,
    cy: 704.13,
    r: 0.67,
    fill: "#f6841f"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 877.4,
    cy: 709.29,
    r: 0.67,
    fill: "#f6841f"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.48,
    cy: 711.27,
    r: 0.67,
    fill: "#f6841f"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.06,
    cy: 705.22,
    r: 0.67,
    fill: "#f6841f"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 874.81,
    cy: 708.63,
    r: 0.67,
    fill: "#f6841f"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 886.46,
    cy: 700.12,
    r: 0.67,
    fill: "#f6841f"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.81,
    cy: 704.13,
    r: 0.67,
    fill: "#f6841f"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 878.06,
    cy: 702.79,
    r: 0.67,
    fill: "#f6841f"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.06,
    cy: 709.6,
    r: 0.67,
    fill: "#f6841f"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.98,
    cy: 708.63,
    r: 0.67,
    fill: "#f6841f"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.31,
    cy: 711.27,
    r: 0.67,
    fill: "#f6841f"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 880.06,
    cy: 711.94,
    r: 0.67,
    fill: "#f6841f"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 883.31,
    cy: 694.98,
    r: 0.67,
    fill: "#f6841f"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.38,
    cy: 700.19,
    r: 0.67,
    fill: "#f6841f"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.38,
    cy: 702.44,
    r: 0.67,
    fill: "#f6841f"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 839.86,
    cy: 698.44,
    r: 0.67,
    fill: "#f6841f"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.88,
    cy: 706.28,
    r: 0.67,
    fill: "#f6841f"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.21,
    cy: 702.44,
    r: 0.67,
    fill: "#f6841f"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 837.38,
    cy: 706.94,
    r: 0.67,
    fill: "#f6841f"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 836.71,
    cy: 693.3,
    r: 0.67,
    fill: "#f6841f"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "850.48 543.63 852.15 594.63 853.98 593.29 855.32 540.79 850.48 543.63",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M877.67,493.67s-11.5-10.84-14-5S855.83,504,855.83,504l12.67,12s2.17-4.17,3.83-4.17a54.81,54.81,0,0,0,6.5-1Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#cf6f80"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "830.15 429.96 822.48 487.62 819.6 483.21 809.98 468.46 811.48 452.62 812.25 426.2 812.48 418.29 830.15 429.96",
    fill: "#cf6f80"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M936.17,372a55.35,55.35,0,0,0-2.6,12.23,30.93,30.93,0,0,1-23.32,10.58,31.28,31.28,0,0,1-7-.8,48.24,48.24,0,0,0,.1-8.34S945.17,343.83,936.17,372Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M941.25,361.81a30.88,30.88,0,0,1-7.42,20.13,31.23,31.23,0,0,1-10.43,7.95,31,31,0,0,1-44.15-28.08,31.62,31.62,0,0,1,.37-4.8,31,31,0,0,1,61.63,4.8Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#cf6f80"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M876.5,452.83c-3.67-3.12-7.78-5.91-8.9-7.92l.23-7.91,17.67,11.67-7.67,57.66L875,501.92c.16-3,.52-5.84,1.22-7.25,2-4,.5-10.17.5-12.17s2.83-5.17,2.66-6.5a79.16,79.16,0,0,0-1-8.33C877.67,464.5,881,456.67,876.5,452.83Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M949.84,563.91V564S928,560.5,911,566.5c-13.94,4.92-31.7,1.1-37.63-.43.65-3.19,1.13-5.07,1.13-5.07s62-18,72.5-3A21.54,21.54,0,0,1,949.84,563.91Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M943.5,403.17l-7.17,16-20.5,12s-22.5-2.17-23.16-2.5-1.72-19.44,4.1-23.46c-1.64,4.62-3.43,14,8.73,14.79a50.46,50.46,0,0,0,32.93-19.59A11.5,11.5,0,0,0,943.5,403.17Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M970.17,435.17l-.34,7.5L949.83,562S928,558.5,911,564.5s-39.67-1-39.67-1,3.17-9,1.84-12.33-.34-13.67-.34-13.67,1-4.5-.16-8S875,511.83,875,511.83s-.83-15.16,1.17-19.16.5-10.17.5-12.17,2.83-5.17,2.66-6.5a79.16,79.16,0,0,0-1-8.33c-.66-3.17,2.67-11-1.83-14.84s-9.67-7.16-9.17-9.16-5.16-1.5-5.16-1.5a12.39,12.39,0,0,1,1.33-6.84c1.83-3.66,1-10.83,1-10.83s4-.17,3.5-5.17a29.21,29.21,0,0,1,.17-8.16s1.66,1.5,6.5,1.33,10.16,1.17,11.66-.33,8.17-6.67,11.5-5.5h0c-.26.51-8.23,16.34,7.68,17.32a50.45,50.45,0,0,0,33.84-20.84s1.83-2,7.83,4.51,11.16,4,11.16,4l6.67.5s-4.33,3.66-1.67,6.16a17.3,17.3,0,0,1,1.57,1.75c2.67,3.31,6.18,8.85,8.1,10.09C975.33,429.67,970.17,435.17,970.17,435.17Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M864.17,496s-24.5,12-20.17,23.33,10.5,9.84,14.17,8.5S868.5,516,868.5,516Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#cf6f80"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M933.25,428.93c0,1.07-6.25,14.57,0,18.07S933.25,428.93,933.25,428.93Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M884,424.25s-8.83,9.5-5.17,10.5S884,424.25,884,424.25Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M943.5,442.83s3.83,23.67,4,30.67,1.17,18.33,1.17,18.33,2.83,27-1.5,38-3.67,23-3.67,23S930.83,577.5,929,580s1.5,26.17,14.83,16.17,11.67-31.84,11.67-31.84l4.67-15,6.5-19.16s1.83-11.67,2.5-14,0-15,0-15S977,437,966.5,430.33,943.5,442.83,943.5,442.83Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#cf6f80"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M943.5,451s15.67-17.17,20.5-15.67,6.17.84,6.17.84.66-9.5-6.5-13-15-14.17-21-1.5S943.5,451,943.5,451Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M943.5,450s15.67-17.17,20.5-15.67,6.17.84,6.17.84.66-9.5-6.5-13-15-14.17-21-1.5S943.5,450,943.5,450Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M964.9,418.08a31.7,31.7,0,0,1-3.63,2.71,27,27,0,0,1-10.49,4,23.43,23.43,0,0,1-9.46-.53,22.91,22.91,0,0,1-7.64-3.55,19.42,19.42,0,0,1-5.79-6.43c-.2-.36-.38-.72-.55-1.08-3.36-7.08-2.46-15.51-3.94-23.32-.11-.55-.23-1.11-.36-1.66a27.19,27.19,0,0,0-7.7-13.67c-5.35-5.17-12.56-8.31-20-12.21-4.33-2.28-8-4.09-12.92-4.73a16.77,16.77,0,0,1-2.83-.61,31,31,0,1,1,54.21,24.93c-.12.79-.2,1.56-.26,2.29-.7,8.86,2.07,13.64,4.86,16.18.3.28.61.52.91.75,0,0,1.83-2,7.83,4.51s11.16,4,11.16,4l6.67.5s-4.33,3.66-1.67,6.16A17.3,17.3,0,0,1,964.9,418.08Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M876,344.25c2.23-2.65,5.55-4.07,8.66-5.6s6.3-3.42,7.8-6.54c2.62-5.42-.5-13.15,4-17.21,2.15-1.95,5.31-2.19,8.21-2.19a44.36,44.36,0,0,1,14,1.86c6.9,2.29,12.66,7,18.8,10.93s13.37,7.09,20.51,5.69c4.17-.81,8.62-3.12,12.38-1.13,2.26,1.2,3.55,3.71,4.12,6.21a17,17,0,0,1-.44,9.06c-1.63,4.91-5.44,8.86-7.12,13.75-.62,1.81-.91,3.93.09,5.56,1.17,1.89,3.66,2.49,5.88,2.41s4.42-.67,6.63-.42c6.34.72,10,7.95,10,14.33s-2.21,12.6-2.28,19c-.09,8.75,4.07,17.16,10,23.59a47.35,47.35,0,0,0,24.8,14.13,18.71,18.71,0,0,1-17.19.51c-12.87-6.33-14.84-25.15-27-32.68a4.14,4.14,0,0,0-2.38-.81c-1.59.1-2.59,1.7-3.41,3.06-4.59,7.67-12.29,13.73-21.13,15.06s-18.58-2.67-22.89-10.51-2.76-17.41-4.85-26.06c-3.63-15-15.37-19.4-27.67-25.88-4.33-2.28-8-4.09-12.92-4.73C876.33,354.83,870.49,350.77,876,344.25Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#512e4e"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M894.07,329.35c2.36-4.88.08-11.63,2.86-15.89a6.61,6.61,0,0,0-.91.69c-4.45,4.05-1.33,11.78-3.95,17.2A9.44,9.44,0,0,1,891,333,10.62,10.62,0,0,0,894.07,329.35Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.4,435.42c-12.88-6.33-14.85-25.15-27.06-32.69a4.19,4.19,0,0,0-2.38-.81c-1.28.08-2.17,1.13-2.9,2.25a2.51,2.51,0,0,1,.9-.25,4.19,4.19,0,0,1,2.38.81c12.21,7.54,14.18,26.36,27.06,32.69a18.72,18.72,0,0,0,17.18-.51c-.59-.13-1.19-.27-1.78-.42A18.76,18.76,0,0,1,1006.4,435.42Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.42,420.05c-8.83,1.33-18.58-2.68-22.88-10.51s-2.76-17.42-4.85-26.06c-3.64-15-15.38-19.4-27.68-25.88-4.32-2.29-8-4.09-12.91-4.73-6-.79-11.77-4.73-6.74-11.07a12.15,12.15,0,0,0-1.75,1.69c-5.48,6.52.36,10.58,6.49,11.38,4.91.64,8.59,2.44,12.91,4.73,12.3,6.48,24,10.84,27.68,25.88,2.09,8.64.56,18.27,4.85,26.06s14.05,11.84,22.88,10.51a29.38,29.38,0,0,0,16.92-9.42A28.7,28.7,0,0,1,952.42,420.05Z",
    transform: "translate(-55.35 -18.71)"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M241.1,797c-6.18-.71-14.91-6.78-20.38-11,2.72-1.59,4.52-2.69,4.52-2.69s-13-13.07-11.43-21.62-3.12-47.51-3.12-47.51-7.28-5.53-3.38-19.61,3.9-17.6,3.9-17.6-2.34-17.85-.78-22.12S212,641.22,212,641.22l3.11-32.29,1.68-12.08c2.83,9.26,7.57,15.38,15,10.18,17.16-12.07,4.42-51.54,4.42-51.54S234,547,232.45,539.9l.85-2.26s-.52-8.79,3.9-11.81,0-68.13,0-68.13l-1.47-39.48h0l0-1.17a36.58,36.58,0,0,0-18.93-30.75l-1.06-.55c-.06-.36-.12-.72-.18-1.1-.84-5.12-1.78-11.28-2.4-17.38-.07-.66-.13-1.31-.19-2C230.8,360.8,244,345.09,244,326.38a38.88,38.88,0,0,0-1.46-10.57c-.07-.26-.15-.52-.23-.77,2.38-2.38,4.33-3.07,4.51-1.52.26,2.26,2.21-.63,2.34-2.89s.65-.63,2-.63,1.56-2.39-.52-3.64.39-2.64,1-2.89.65-2.64,0-2.64a.65.65,0,0,1-.23-.07l-.07,0a3.53,3.53,0,0,1-.33-.17h0l-.41-.26-.11-.07-.45-.32h0c-1.19-.85-2.56-2-2.56-2l.65-.5c.65-.5-.78-1.76-2-1.88l-.25,0h0c-1.22-.19-3.17-.89-1.93-1.47.28-.13.4-.28.42-.44h0a.6.6,0,0,0-.22-.46h0a2.63,2.63,0,0,0-.6-.42h0l-.37-.17h0l-.36-.12h0a2.7,2.7,0,0,0-.39-.08h-.08l-.36,0-.29,0a28.22,28.22,0,0,1-4.91-1.74v-2.64L234.6,287h0l-1.82-.8.65-2.43h-5.72l.78-2.14-2.63-.51-.62-.12v-1l-3.51-1.38v-1.51h-4.22l1.62-1.26h-3.25c-8.49-5.82-32.4-5.4-41.93-2.22s-12.31,5.53-25.3,32.85c-8.31,17.46,2.3,34.39,11.62,43.84h0c.31.32.62.62.93.92l.13.13.83.79.08.07.89.81.1.08.78.68.11.09.84.69,0,0,.76.59.13.1c.51.39,1,.73,1.45,1l.14.09.6.39.05,0c.2.13.4.24.59.35l.12.07.45.24.1,0,.47.21.08,0,.33.12.09,0a2.46,2.46,0,0,0,.33.07H171a.49.49,0,0,0,.18-.08,12.47,12.47,0,0,1,3.86-1.24l1,.8c.48.39,1,.76,1.48,1.12.12.73.22,1.47.31,2.24a40.25,40.25,0,0,1-.94,14.64c-.1.37-.21.74-.32,1.11a19.68,19.68,0,0,0-10.8,8.23c-11.18,17.35-16.12,27.66-16.12,27.66S148,424,145.18,426.78s5.2,52.54,5.2,52.54-9.62,19.1-1,22.5-.78,6.16-.78,6.16,2.6,5.78-2.34,6.28-7.8,9.31-7.8,9.31l-15.33,16.59,3.86,1.32c-.33.52-.67,1.06-1,1.67-5.12,8.56-12.86,26-7.77,47,7.28,30.17,9.36,36.7,9.1,42s8.31,26.15,6.23,30.92-3.24,21.37.33,25.65-1.36,6.78-1.36,6.78,5.32,6.29,2.66,10.56,3.31,57.07,3.31,57.07,9.62,13.58,9.1,17.85-4.94,6.54-1,8.3,2.34,4.27,2.34,4.27l1,.08c-.89.8-1.74,1.64-2.52,2.49a23.58,23.58,0,0,0-2.13,2.68,12.44,12.44,0,0,0-.88,1.56c-3.5,7.7,5.82,13.58,5.82,13.58h0l1,0,.24,0h.36l.51,0h.23l.84,0h0c9.05.36,34.63,1,46.69-2l.22.14s45.75,2.46,54.84-3.83S250.72,798.1,241.1,797Zm-46.85,2.21-.33-.05-.52-.09-.37,0-.58-.09-.16,0h-.08c-.43-.06-.86-.12-1.28-.16a20.92,20.92,0,0,1-5.92-1.82c-1.32-.59-2.66-1.3-4-2.06l2.64-.06c.69,0,1.37,0,2-.07l1.19-.06h0c3,0,7.3.4,8.43,2.43A10.43,10.43,0,0,0,194.25,799.2Z",
    transform: "translate(-55.35 -18.71)",
    fill: "url(#05d1d1fb-9375-46f7-a562-a16a81ed75db)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M219,398.75c-.75,0-59.75,11.25-45-8.75A35.87,35.87,0,0,0,180,377.46a41.33,41.33,0,0,0,.9-14.56A51.35,51.35,0,0,0,176,346s48.75-10.75,41-2.5c-3.38,3.6-3.29,14.59-2.17,25.82.6,6.07,1.5,12.2,2.31,17.29C218.28,393.7,219.24,398.75,219,398.75Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#ffccd0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M169,783.22s15.25,14.06,24.5,15.16,22.25,5.09,13.5,11.34-52.75,3.81-52.75,3.81-10.19-6.66-4.75-15.06S169,783.22,169,783.22Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M207,809.72a16.22,16.22,0,0,1-5.48,2.13c-14.65,3.49-47.27,1.68-47.27,1.68s-10.19-6.66-4.75-15.06S169,783.22,169,783.22s15.25,14.06,24.5,15.16l1.31.17C203.91,799.85,215.34,803.76,207,809.72Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M207,809.72a16.22,16.22,0,0,1-5.48,2.13l-1-.05s-8.77-5.72-5.69-13.25C203.91,799.85,215.34,803.76,207,809.72Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M217.25,781.5s15.25,14,24.5,15.15,22.25,5.1,13.5,11.35-52.75,3.8-52.75,3.8-10.19-6.65-4.75-15S217.25,781.5,217.25,781.5Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M217.25,781.5s15.25,14,24.5,15.15,22.25,5.1,13.5,11.35-52.75,3.8-52.75,3.8-10.19-6.65-4.75-15S217.25,781.5,217.25,781.5Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M202.25,791.75c-2,1.47-6.8,2.24-12.61,2.58h-.09l-1.09.06c-.64,0-1.3.06-2,.07-14.63.47-33.5-1.21-33.5-1.21s1.5-2.5-2.25-4.25.5-4,1-8.25S143,763,143,763s-5.75-52.5-3.19-56.75-2.56-10.5-2.56-10.5,4.75-2.5,1.31-6.75-2.31-20.75-.31-25.5-6.25-25.5-6-30.75S130.5,621,123.5,591c-4.89-21,2.55-38.26,7.47-46.78a47.34,47.34,0,0,1,3.78-5.72H182.5l1.21,11.24.06.62c.4,3.79.89,8.38,1.44,13.65C191.88,627.43,208.06,787.54,202.25,791.75Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M202.25,791.75c-2.17,1.57-7.45,2.34-13.79,2.64a33.69,33.69,0,0,0-5,.07s-.75-1.71-9.75-8,0-20.5,0-20.5l-9.36-38.25S162,717.5,164,711.5s-4.31-7.5-4.31-7.5,6.31-4,0-9.25-7.19-24.5-7.19-24.5-9-12-5-16-2.5-13.5-2.5-13.5-9.5-15-8.5-20S151,617.5,147,601.5s20.65,6,20.65,6l16.12-57.14C189,599.8,208.54,787.19,202.25,791.75Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5,783s-27,17-28.75,13.75c-1.09-2-5.18-2.41-8.11-2.42h-.09c-1.74,0-3.05.13-3.05.13s-.75-1.71-9.75-8,0-20.5,0-20.5l-9.36-38.25S165,717.5,167,711.5s-4.31-7.5-4.31-7.5,6.31-4,0-9.25-7.19-24.5-7.19-24.5-9-12-5-16-2.5-13.5-2.5-13.5-9.5-15-8.5-20,0-4-4-20c-3-12.06,4.76-39.17,8.78-51.79,1.31-4.13,2.22-6.71,2.22-6.71l37.21,7.49L221,557.25l1,13.25-.28,2.1-5,37-3,32.11s0,9.25-1.5,13.5.75,22,.75,22,0,3.5-3.75,17.5,3.25,19.5,3.25,19.5,4.5,38.75,3,47.25S226.5,783,226.5,783Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M171.63,690c3.75.63,23.12,1,18,3.38S171.63,690,171.63,690Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5,702.63c1.5-.13,8.38-3.13,10.25-2.88s4.38-.53,6.63,0,6.46,2,4.1,2.89-7.3.12-10.14,1S169.5,702.63,169.5,702.63Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M149,697.38c1-.13,8.75-2.13,8.13,0S149,697.38,149,697.38Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M136.63,634.63c.75,1,5.12,11,7.25,11S136.63,634.63,136.63,634.63Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M217,343.5c-3.38,3.6-3.29,14.59-2.17,25.82a40.09,40.09,0,0,1-10.29,1.34c-8.87,0-9.57-11.19-16.2-16.06C187.29,344.85,176,346,176,346S224.75,335.25,217,343.5Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M244.54,328.66a40,40,0,1,1-1.4-10.51A40,40,0,0,1,244.54,328.66Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#ffccd0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M219,398.75c-.75,0-59.75,11.25-45-8.75A35.87,35.87,0,0,0,180,377.46c11.93-3.81,26.55,2.54,26.55,2.54l6.75,5a23.22,23.22,0,0,1,3.89,1.61C218.28,393.7,219.24,398.75,219,398.75Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M222,570.5l-.28,2.1c-1.59.54-8.9,2.57-26.38-4.6-2.81-1.15-6.28-2.51-10.13-4-12.41-4.75-28.89-10.73-40.93-15-5.77-2.07-10.52-3.76-13.31-4.74a47.34,47.34,0,0,1,3.78-5.72H182.5l1.21,11.24L221,557.25Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5,381s-26.5-11.5-37.25,5.75-15.5,27.5-15.5,27.5-1.5,11.5-4.25,14.25,5,52.25,5,52.25-9.25,19-1,22.37-.75,6.13-.75,6.13,2.5,5.75-2.25,6.25-7.5,9.25-7.5,9.25l-14.75,16.5s48.17,17,67.09,24.75,25.91,4.75,26.66,4.5,12.25-31.75,12.25-31.75S233.75,530,238,527s0-67.75,0-67.75l-1.46-40.43a36.55,36.55,0,0,0-18.21-30.57,25.32,25.32,0,0,0-5.08-2.25Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M232.75,450l5.25,9.25s-42,12-43.65.5c-.25-1.68,16.4-15,16.4-15Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M232.75,450l5.25,9.25s-42,12-43.65.5c-.25-1.68,16.4-15,16.4-15Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M161.25,500s20-6.5,15.75-1.25S161.25,500,161.25,500Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M184.07,501.46s10.23,12.78,12.68,8S184.07,501.46,184.07,501.46Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M243.14,318.15a25.88,25.88,0,0,0-3.52,4.47c-3.5,5.5-6.12,5.63-6.12,5.63s0,11.9-1.62,13.14-10.88-5.27-11-6.89-11.43-19.25-16.34,3.12l-.92,18.13s-16.2,2-24.49,3.81a40,40,0,1,1,64-41.41Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5,278.38h3.13l-1.57,1.25h4.07v1.5l3.37,1.37v1l3.13.63-.75,2.12h5.5l-.63,2.41,3.75,1.72V293s3.75,1.75,5,1.75,3.32,1.13,2,1.75,1,1.38,2.09,1.5,2.5,1.38,1.87,1.88l-.62.5s3.37,2.87,4,2.87.62,2.38,0,2.63-3,1.62-1,2.87,1.75,3.63.5,3.63-1.75-1.63-1.88.62-2,5.13-2.25,2.88-4.12.25-7.62,5.75-6.13,5.62-6.13,5.62,0,11.9-1.62,13.14-10.88-5.26-11-6.89-11.43-19.25-16.34,3.13l-.91,18.12s-27,3.38-29.13,5.25-34.17-24-21.67-51.17,15.17-29.5,24.34-32.66S209.33,272.58,217.5,278.38Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#3f3d56"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5,454.25s-.25,20.25-2,25.25,12,51.75,12,51.75,11,24.65,9,32.25.75,56.25,17.25,44.25S237,556.5,237,556.5s-5.25-21.86-5.25-24.55-5.5-43.2-5.5-43.2-4.25-13.25-3-21.25S225,444.75,225,444.75Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#ffccd0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M213.25,416.25s-20.06,6.5-20.9,24.25,0,19.25,0,19.25,29.9-15,43.65-.5L234.59,420Z",
    transform: "translate(-55.35 -18.71)",
    opacity: 0.1
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M215.25,416.25s-20.06,6.5-20.9,24.25,0,19.25,0,19.25,29.9-15,43.65-.5L236.59,420Z",
    transform: "translate(-55.35 -18.71)",
    fill: "#f6841f"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.22,294.73c-.45.56,1.41,1.16,2.41,1.27a1.63,1.63,0,0,1,.3.07c.07-.61-1.43-1.32-2.43-1.32Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5,291s.92.43,2,.86v-1.48l-2-.92Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.39,298l-.51.41s1.15,1,2.24,1.8l.38-.3c.63-.5-.75-1.75-1.87-1.88Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.4 267.96 178.65 268.98 179.02 267.54 176.51 267.54 176.4 267.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.54,334.63l-.91,18.12s-27,3.38-29.13,5.25c-.66.59-4.25-1.54-8.49-5.57,5.06,5.31,9.72,8.25,10.49,7.57,2.13-1.87,29.13-5.25,29.13-5.25l.91-18.12c2.87-13.12,8-12.49,11.68-9.4C212.54,322.9,206,319,202.54,334.63Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.88,308.75c-2-1.25.37-2.62,1-2.87s.62-2.63,0-2.63a4.65,4.65,0,0,1-1.54-.91c0,.66-.13,1.4-.46,1.54-.63.25-3,1.62-1,2.87s1.75,3.63.5,3.63-1.75-1.63-1.88.62-2,5.13-2.25,2.88-4.12.25-7.62,5.75-6.13,5.62-6.13,5.62,0,11.9-1.62,13.14c-1.13.85-5.87-2-8.75-4.34,1.47,2.18,9.26,7.47,10.75,6.34s1.62-13.14,1.62-13.14,2.63-.12,6.13-5.62,7.37-8,7.62-5.75,2.13-.63,2.25-2.88.63-.62,1.88-.62S252.88,310,250.88,308.75Z",
    transform: "translate(-55.35 -18.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.52 265.54 174.23 265.54 174.27 265.42 171.75 264.91 171.52 265.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.77 261.23 167.77 260.92 167 260.92 167.77 261.23"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M248.66,588.06S331,463,428,534s120.83,116,201.92,91S708,550.86,772,568.93s86.17-41.1,86.17-41.1",
    transform: "translate(-55.35 -18.71)",
    fill: "none",
    stroke: "#f6841f",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 849.33,
    y: 502.51,
    width: 17.67,
    height: 39.49,
    rx: 8.83,
    ry: 8.83,
    transform: "translate(221.51 -315.77) rotate(23.32)",
    fill: "#f6841f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawChildren4Rtb);
export default __webpack_public_path__ + "static/media/undraw_children_4rtb.a53cc5cc0a3ebc860454d374dae8187a.svg";
export { ForwardRef as ReactComponent };